import React, { useState } from 'react';
import { useStripe, useElements, CardElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Modal, ModalBody, Button, ButtonToolbar } from 'reactstrap';
import classNames from 'classnames';
import CardSection from './CardSection';

const stripePromise = loadStripe(process.env.STRIPE_PUB_KEY);

function InnerCardSetupModal(props) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async function (e) {
	e.preventDefault();
	if (!stripe || !elements || loading) return;

	setLoading(true);
	setError(false);

	const result = await stripe.confirmCardSetup(props.clientSecret, {
	  payment_method: {
		card: elements.getElement(CardElement),
		billing_details: {
		  name: props.user.name,
		  email: props.user.email
		}
	  }
	});

	if (result.error) {
	  setError(result.error.message || 'Card setup failed');
	  setLoading(false);
	} else {
	  props.onComplete();
	}
  };

  const modalClass = classNames({
	'modal-dialog--colored': false,
	'modal-dialog--header': true
  });

  return (
	<Modal
	  isOpen={props.isOpen}
	  toggle={props.onClose}
	  modalClassName="ltr-support"
	  className={'modal-dialog--primary ' + modalClass}
	>
	  <form onSubmit={handleSubmit}>
		<div className="modal__header">
		  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={props.onClose} />
		  <h4 className="text-modal modal__title">Add a Payment Method</h4>
		</div>
		<ModalBody>
		<div className="modal__message-container">
		  <h5>No card saved yet.</h5>
		  <p>To continue, please add a credit card. We’ll store it securely and use it for future purchases only when needed.</p>
		</div>
		  <div className="cc-title">Enter Credit Card Information</div>
		  <div className="card-input">
			<CardSection />
		  </div>
		  {error && <div className="payment-error mt-2">{error}</div>}
		</ModalBody>
		<ButtonToolbar className="modal__footer">
		  <Button className="modal_cancel" onClick={props.onClose}>Cancel</Button>{' '}
		  <Button className="modal_ok" type="submit" color="primary">
			{loading ? 'Adding Card...' : 'Add Card'}
		  </Button>
		</ButtonToolbar>
	  </form>
	</Modal>
  );
}

export default function StripeCardSetupModal(props) {
  return (
	<Elements stripe={stripePromise} options={{ clientSecret: props.clientSecret }}>
	  <InnerCardSetupModal {...props} />
	</Elements>
  );
}
